import { GET_FURNITURE_TYPES_LOADING, GET_FURNITURE_TYPES_SUCCESS } from '../actionTypes';
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';

export const getFurnitureTypesSuccess = payload => {
    return ({
        type: GET_FURNITURE_TYPES_SUCCESS,
        payload
    })
}

export const getFurnitureTypesAsync = payload => dispatch => {
    return client.service('furniture-types').find()
		.then((response) => {
            dispatch(getFurnitureTypesSuccess(response));
            return response
		})
        .catch((error) => {
            console.error('error', error);
        })
           
}